enum PatrimonyTypeEnum {
    MATERIAL = 'MATERIAL', //Material
    INTANGIBLE = 'INTANGIBLE', //Imaterial
}

export default PatrimonyTypeEnum;
